module.exports = __webpack_public_path__ + "static/CRO-trends-to-watch-288172aba7d4d132938bf8981e3dfa6c.png";